import classNames from 'classnames';
import * as React from 'react';
import type { QueryParameter } from '~/Partials/SearchBase/QueryParameterUtils';
import { formatQueryParameters } from '~/Partials/SearchBase/QueryParameterUtils';
import styles from './Vimeo.module.css';

export interface VimeoProps {
    videoId: string;
    title: string;
    autoplay?: boolean;
    className?: string;
}

export class Vimeo extends React.PureComponent<VimeoProps> {
    render() {
        const { videoId, title, autoplay, className } = this.props;

        let id = videoId;

        const parameters: QueryParameter[] = [];

        if (autoplay) {
            parameters.push({ name: 'autoplay', value: '1' });
        }

        // ID can contain privacy hash (for unlisted videos) after ':'
        if (videoId.includes(':')) {
            const segments = videoId.split(':');

            id = segments[0];

            parameters.push({ name: 'h', value: segments[1] });
        }

        return (
            <div className={classNames(styles.Vimeo, className)}>
                <iframe
                    loading="lazy"
                    title={title}
                    src={`https://player.vimeo.com/video/${id}${formatQueryParameters(parameters)}`}
                    width="640"
                    height="480"
                    allow="autoplay; fullscreen"
                    data-ready="true"
                />
            </div>
        );
    }
}
